
import './LoadingAnimation.css';
import { useUploadProgress } from '../../data/GlobalStates';
import { useAtom } from 'jotai';

const LoadingAnimation = ({classVariant}) => {

  //stany globalne:

  const [ UploadProgress, setUploadProgress ] = useAtom(useUploadProgress);

 

  return (
        <div id='AnimationMainContainer'>

<div className="loader">
  <span style={{ "--i": 1 }}>P</span>
  <span style={{ "--i": 2 }}>o</span>
  <span style={{ "--i": 3 }}>l</span>
  <span style={{ "--i": 4 }}>s</span>
  <span style={{ "--i": 5 }}>k</span>
  <span style={{ "--i": 6 }}>a</span>
  <span style={{ "--i": 7 }}>&nbsp;</span>
  <span style={{ "--i": 8 }}>A</span>
  <span style={{ "--i": 9 }}>k</span>
  <span style={{ "--i": 10 }}>a</span>
  <span style={{ "--i": 11 }}>d</span>
  <span style={{ "--i": 12 }}>e</span>
  <span style={{ "--i": 13 }}>m</span>
  <span style={{ "--i": 14 }}>i</span>
  <span style={{ "--i": 15 }}>a</span>
  <span style={{ "--i": 16 }}>&nbsp;</span>
  <span style={{ "--i": 17 }}>T</span>
  <span style={{ "--i": 18 }}>y</span>
  <span style={{ "--i": 19 }}>c</span>
  <span style={{ "--i": 20 }}>z</span>
  <span style={{ "--i": 21 }}>k</span>
  <span style={{ "--i": 22 }}>i</span>
</div>

            { UploadProgress ? <h2 className='UploadProgressDisplayer'>{UploadProgress}</h2> : null }
        </div>
    )
}

export default LoadingAnimation;
